'use client';

import { UIMarket } from '@drift/common';
import MarketIcon from 'src/components/Utils/MarketIcon';
import NumberDisplay from 'src/components/NumberDisplay/NumberDisplay';
import { BalanceRowData } from './types';

interface EarningsCellProps {
	row: BalanceRowData;
}

export function EarningsCell({ row }: EarningsCellProps) {
	const { spotMarketIndex, base90DayEarning, quote90DayEarning } = row;
	const uiMarket = UIMarket.createSpotMarket(spotMarketIndex);

	return (
		<div className="flex flex-col gap-y-xs">
			<div className="flex items-center gap-x-xs">
				<MarketIcon
					marketSymbol={uiMarket.uiSymbols.marketDisplaySymbol}
					className="size-lg"
				/>
				<NumberDisplay
					value={base90DayEarning}
					type="number"
					precision="trade"
					className="typo-t4 text-text-default"
					loading={base90DayEarning === undefined}
					skeletonClassName="h-3 w-10"
					isAccountValueToHide
					trimZeroes
				/>
			</div>
			<NumberDisplay
				value={quote90DayEarning}
				type="currency"
				className="typo-b4 text-text-secondary"
				loading={quote90DayEarning === undefined}
				skeletonClassName="h-4 w-12"
				isAccountValueToHide
			/>
		</div>
	);
}
